import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

export const EMAIL_SETTINGS_PATH = "/settings/email";

export const EMAIL_SETTINGS_DOCK_PAGE_ID = "email";

export const EMAIL_SENDER_TARGET_KIND = "emailSender";

export const NEW_EMAIL_SENDER_TARGET_KIND = "newEmailSender";

const NEW_SENDER_ROUTE_SEGMENT = "new";

const SENDER_ROUTE_PATTERN = /^\/settings\/email\/senders\/([^/?#]+)$/;

const senderRouteSegment = (pathname: string): null | string => {
	const match = SENDER_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return decodeURIComponent(match[1]);
	} catch {
		return null;
	}
};

const buildSenderPath = (segment: string): string => `${EMAIL_SETTINGS_PATH}/senders/${encodeURIComponent(segment)}`;

export const isEmailSettingsRoute = (pathname: string): boolean =>
	pathname === EMAIL_SETTINGS_PATH || pathname.startsWith(`${EMAIL_SETTINGS_PATH}/`);

export const matchEmailSenderReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const segment = senderRouteSegment(pathname);
	return segment && segment !== NEW_SENDER_ROUTE_SEGMENT
		? { targetId: segment, targetKind: EMAIL_SENDER_TARGET_KIND }
		: null;
};

export const NEW_EMAIL_SENDER_TARGET: ContinuationTarget = {
	targetId: NEW_SENDER_ROUTE_SEGMENT,
	targetKind: NEW_EMAIL_SENDER_TARGET_KIND
};

export const matchNewEmailSenderReceiverRoute = (pathname: string): ContinuationTarget | null =>
	senderRouteSegment(pathname) === NEW_SENDER_ROUTE_SEGMENT ? NEW_EMAIL_SENDER_TARGET : null;

export const newEmailSenderReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: () => buildSenderPath(NEW_SENDER_ROUTE_SEGMENT),
	matchesRoute: matchNewEmailSenderReceiverRoute
};

const emailSenderReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => buildSenderPath(targetId),
	matchesRoute: matchEmailSenderReceiverRoute
};

export default emailSenderReceiverIdentityAdapter;
